import { createStyles, rem } from '@mantine/core'

type StylesParams = {
  opened: boolean
}

export default createStyles((_theme, { opened }: StylesParams) => {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: rem(8),
    },
    targetBtn: {
      display: 'flex',
      alignItems: 'center',
      gap: rem(8),
      cursor: 'pointer',
    },
    dropdown: {
      display: opened ? 'block' : 'none',
    },
    icon: {},
    arrowIcon: {},
    targetText: {},
    scrollThumb: {
      backgroundColor: '#D9D9D9',
    },
  }
})
